import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Clock, Loader2, XCircle } from 'lucide-react';
import { api } from '../lib/api';
import { money } from '../hooks/usePageContent';

const RentalSuccess = () => {
    const [params] = useSearchParams();
    const [r, setR] = useState(null);
    const [error, setError] = useState('');
    const sid = params.get('session_id');

    useEffect(() => {
        let tries = 0;
        let timer;
        const poll = async () => {
            try {
                const { data } = await api.get(`/rentals/status/${sid}`);
                setR(data);
                if (data.deposit_status === 'pending' && ++tries < 10) timer = setTimeout(poll, 2000);
            } catch { setError('We could not find this rental request.'); }
        };
        poll();
        return () => clearTimeout(timer);
    }, [sid]);

    const ok = r && ['paid', 'processing'].includes(r.deposit_status);
    const Icon = !r ? Loader2 : ok ? (r.deposit_status === 'paid' ? CheckCircle2 : Clock) : XCircle;

    return (
        <div className="container-page pt-32 pb-24 max-w-3xl" data-testid="rental-success-page">
            {error && <p className="text-red-600" data-testid="rental-status-error">{error}</p>}
            {!error && (
                <div data-testid={`rental-status-${r?.deposit_status || 'loading'}`}>
                    <Icon className={`h-14 w-14 ${!r ? 'animate-spin text-neutral-400' : ok ? 'text-emerald-600' : 'text-amber-600'}`} />
                    <h1 className="mt-6 font-display font-black uppercase tracking-tighter text-5xl text-neutral-900">
                        {!r ? 'Confirming…' : ok ? 'Booking request received' : 'Deposit not completed'}
                    </h1>
                    {r && (
                        <div className="mt-6 text-neutral-700 space-y-1">
                            <p>Request <b data-testid="rental-request-number">{r.request_number}</b> · {r.machine_name || r.course_name}</p>
                            <p>Deposit {money(r.deposit)} — {r.deposit_status === 'paid' ? 'paid' : r.deposit_status === 'processing' ? 'bank payment processing' : 'not paid'}.</p>
                            {ok && <p>We&apos;ll contact you at {r.email} within one business day to confirm your dates.</p>}
                        </div>
                    )}
                    <Link to="/rental" className="mt-8 inline-block bg-brand-primary hover:bg-brand-primaryHover text-white font-bold px-6 py-3 label-caps transition-colors" data-testid="rental-success-back">Back to rentals</Link>
                </div>
            )}
        </div>
    );
};

export default RentalSuccess;
